import type { ComponentType } from 'react';
import {
  Archive,
  Laptop,
  Briefcase,
  Building2,
  CalendarDays,
  ClipboardCheck,
  Contact,
  CreditCard,
  FileText,
  FolderKanban,
  FolderOpen,
  HandCoins,
  LayoutDashboard,
  LineChart,
  Settings,
  Sheet,
  Target,
  TrendingUp,
  UserRoundCheck,
  Users,
} from 'lucide-react';

export const NAV_ICONS: Record<string, ComponentType<{ className?: string }>> = {
  '/': LayoutDashboard,
  '/customers': Building2,
  '/contacts': Contact,
  '/leads': Target,
  '/calendar': CalendarDays,
  '/tasks': ClipboardCheck,
  '/projects': FolderKanban,
  '/invoices': FileText,
  '/payments': CreditCard,
  '/vendor-advices': HandCoins,
  '/revenue': Archive,
  '/revenue2': TrendingUp,
  '/invoice-analytics': LineChart,
  '/resource-billing': Users,
  '/recruitment': Briefcase,
  '/onboarding': UserRoundCheck,
  '/assets': Laptop,
  '/documents': FolderOpen,
  '/reports': Sheet,
  '/settings': Settings,
};
